// Dependencies
import { combineReducers } from "redux";

// Reducers
import preciosCliente from "./app/comercial/consultaPreciosCliente/redux/reducer";
import tarifasVenta from "./app/others/tarifasVenta/redux/reducer";
import tiposMargen from "./app/others/tiposMargen/redux/reducer";
import articulos from "./app/others/articulos/redux/reducer";
import proveedores from "./app/others/proveedores/redux/reducer";
import perfiles from "./app/others/perfiles/redux/reducer";
import tiposUnidad from "./app/others/tiposUnidad/redux/reducer";
import tiposActCoste from "./app/others/tiposActCoste/redux/reducer";
import etiquetasCompras from "./app/others/etiquetasCompras/redux/reducer";
import repartidores from "./app/configuracion/repartidores/redux/reducer";
import usuarios from "./app/configuracion/usuarios/redux/reducer";
import empleados from "./app/empleados/redux/reducer";

const rootReducer = combineReducers({
  preciosCliente,
  tarifasVenta,
  tiposMargen,
  articulos,
  proveedores,
  perfiles,
  repartidores,
  empleados,
  usuarios,
  tiposUnidad,
  tiposActCoste,
  etiquetasCompras,
});

export default rootReducer;
